import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export function useConfig() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/config").then(r => setCfg(r.data)).catch(() => setCfg({})); }, []);
  return cfg;
}
